import request from './networkconfig'

/**
 * 查询条件
 * - `{"ARTICLE_ID":{"_value":"10","_operation":"0"}}`
 * - 操作符代号
 * 	- 0: =, 1: in, 2: like,
 * 	- 3: 大于, 4: 小于, 5: 大于等于  6：小于等于
 * 	- 8: IS NULL, 9: IS NOT NULL, 10 : !=
 * @param {{}} p2_condition 查询条件
 * @example
 * {"field:0": value} => {'field:0': { _value: value, _operation: 0 }}
 * - SQL: WHERE field = value
 *
 * AND
 * {"f1:2": 10, "f3:0": 20} => {'f1:'}
 * - SQL: WHERE f1 like '%10%' AND f3 = 20
 *
 * OR - 优先 || 分割值，再否则用 ',' 分割值
 * {'f1:2,f2:1': 10} =>
 * - SQL: WHERE (f1 like %10% OR f2 IN (10))
 * {'f1:2,f2:1': '10,11'} =>
 * - SQL: WHERE f1 like '%10%' OR f2 IN ('11')
 * {'f1:1,f2:3': '1,2,3||0'} =>
 * - SQL: WHERE f1 IN (1,2,3) OR f2 > 0
 *
 * OR + AND
 * {'f1:2,f2:1': '10,11', 'f3' : 20} =>
 * - SQL: WHERE (f1 like '%10%' OR f2 IN ('11')) AND f3 = 20
 */
function parseP2(p2_condition){
    var result = {};
    for(var opt in p2_condition) {
        var orOpt = opt.split(',');
        var value = p2_condition[opt];
        if(orOpt.length > 1) {
            result[opt] = {
                _value: value,
                _operation: "7"
            }
        } else {
            var arr = opt.split(":");
            var field = arr[0];
            var operation = arr[1];
            if(operation  == '1' && value) {
                //in查询单独处理下
                value = value + '';
                value = value.split(',');
                var vArr = [];
                for(var i = 0; i < value.length; i++) {
                    vArr.push("'" + value[i] + "'");
                }
                value = vArr.join(',');
            }
            result[opt] = {
                _value: value,
                _operation: operation ? operation : "0"
            }
        }
    }
    return result;
}
// pageInfo
function parseP3(p3_condition){
    return {
        pageIndex: p3_condition.pageIndex,
        pageSize: p3_condition.pageSize
    };
}

// deleteRecords
function parseP5(p5_condition){
    return p5_condition;
}

// slaves
function parseP8(p8_condition){
    if(Array.isArray(p8_condition)) {
        p8_condition = p8_condition.join(',');
    }
    return p8_condition;
}

// selectFields
function parseP9(p9_condition){
    var result = p9_condition;
    return result;
}

/**
 * 构建 Sort(ORDER BY 子句) 部分
 * @param {Array} p10_condition 排序条件
 * @example
 * // 对 field1 降序，对 field2 和 field3 降序排列
 * ['field1:DESC', 'field2,field3:ASC']
 */
function parseP10(p10_condition){
    return p10_condition;
}

// p11
function parseP11(p11_condition){
    return p11_condition;
}

// p12 srid
function parseP12(p12_condition){
    return p12_condition;
}

function queryOne(tableName, queryCondition, requestUniqueId) {
    return queryList(tableName, queryCondition, requestUniqueId).then((data)=>{
         return new Promise(function(resolve, reject){
            if(data.result.length > 1) {
                reject('结果不唯一');
            } else {
                data.result = data.result[0];
                resolve(data);
            }
         });
    });
}

function queryList(tableName, queryCondition, requestUniqueId) {
    var p1 = tableName;
    var p2 = parseP2(queryCondition.p2);
    var p8 = parseP8(queryCondition.p8);
    var p9 = parseP9(queryCondition.p9);
    var p10 = parseP10(queryCondition.p10);
    var p12 = parseP12(queryCondition.p12);
    let data = new FormData();
    data.append("param",  JSON.stringify({"p1": p1, "p2": p2, "p8": p8, "p9": p9, "p10": p10, "p12": p12 }));
    return request({
        url: '/data/queryList/' + (requestUniqueId || window.uuid()),
        method: 'post',
        data : data
    });
}

function pageQuery(tableName, queryCondition, requestUniqueId) {
    var p1 = tableName;
    var p2 = parseP2(queryCondition.p2);
    var p3 = parseP3(queryCondition.p3);
    var p9 = parseP9(queryCondition.p9);
    var p10 = parseP10(queryCondition.p10);
    var p11 = parseP11(queryCondition.p11);
    var p12 = parseP12(queryCondition.p12);
    let data = new FormData();
    data.append("param",  JSON.stringify({"p1": p1,"p2": p2, "p3": p3, "p9": p9, "p10": p10, "p11": p11, "p12": p12}));
    return request({
        url: '/data/pageQuery/' + requestUniqueId,
        method: 'post',
        data : data
    });
}

function delRows(tableName, delCondition, requestUniqueId){
    var p1 = tableName;
    var p5 = parseP5(delCondition.p5);
    var p8 = parseP8(delCondition.p8);
    let data = new FormData();
    data.append("param",  JSON.stringify({p1: p1, p5: p5, p8: p8}));
    return request({
        url: '/data/del/' + requestUniqueId,
        method: 'post',
        data: data
    });
}


function save(tableName, row, requestUniqueId) {
    var p1 = tableName;
    var p4 = row;
    let data = new FormData();
    data.append("param",  JSON.stringify({p1: p1, p4: p4}));
    return request({
        url: '/data/save/' + requestUniqueId,
        method: 'post',
        data: data
    });
}

function saveList(tableName, rows, requestUniqueId) {
    var p1 = tableName;
    var p15 = rows;
    let data = new FormData();
    data.append("param",  JSON.stringify({p1: p1, p15: p15}));
    return request({
        url: '/data/saveList/' + requestUniqueId,
        method: 'post',
        data: data
    });
}

function contains(tableName, queryCondition, geo_field, targetWkt, requestUniqueId) {
    var p1 = tableName;
    var p2 = parseP2(queryCondition.p2);
    var p8 = parseP8(queryCondition.p8);
    var p9 = parseP9(queryCondition.p9);
    var p10 = parseP10(queryCondition.p10);
    var p12 = parseP12(queryCondition.p12);
    let data = new FormData();
    data.append("param",  JSON.stringify({"p1": p1, "p2": p2, "p8": p8, "p9": p9, "p10": p10, "p12": p12 }));
    return request({
        url: '/geometry/contains/' + geo_field + '/' + targetWkt +  '/' + requestUniqueId,
        method: 'post',
        data : data
    });
}


function cache_get(tableName, cahceKey, cacheValue, requestUniqueId) {
    let data = new FormData();
    data.append("param",  JSON.stringify({p1: tableName, p13: cahceKey, p14: cacheValue}));
    return request({
        url: '/data/cache/get/' + requestUniqueId,
        method: 'post',
        data: data
    });
}

function getServerDatetime(requestUniqueId){
    requestUniqueId = requestUniqueId ? requestUniqueId : 'getServerDatetime';
    return request({
        url: '/common/server/datetime/' + requestUniqueId,
        method: 'get',
    });
}

function getServerDate(requestUniqueId){
    requestUniqueId = requestUniqueId ? requestUniqueId : 'getServerDate';
    return request({
        url: '/common/server/date/' + requestUniqueId,
        method: 'get',
    });
}
/**
 * 获得本周一至周日的时间段
 */
function getServerWeekRange(requestUniqueId){
    requestUniqueId = requestUniqueId ? requestUniqueId : 'getServerWeekRange';
    return request({
        url: '/common/server/weekRange/' + requestUniqueId,
        method: 'get',
    });
}

/**
 * 获得上周一至周日的时间段
 */
 function getServerLastWeekRange(requestUniqueId){
    requestUniqueId = requestUniqueId ? requestUniqueId : 'getServerLastWeekRange';
    return request({
        url: '/common/server/lastWeekRange/' + requestUniqueId,
        method: 'get',
    });
}

/**
 * 获得本月时间段
 */
 function getServerMonthRange(requestUniqueId){
    requestUniqueId = requestUniqueId ? requestUniqueId : 'getServerMonthRange';
    return request({
        url: '/common/server/monthRange/' + requestUniqueId,
        method: 'get',
    });
}

/**
 * 获得近三天时间段
 */
 function getServerNearThreeDaysRange(requestUniqueId){
    requestUniqueId = requestUniqueId ? requestUniqueId : 'getServerNearThreeDaysRange';
    return request({
        url: '/common/server/nearThreeDaysRange/' + requestUniqueId,
        method: 'get',
    });
}

export default {
    queryList: queryList,
    pageQuery: pageQuery,
    delRows  : delRows,
    save     : save,
    saveList : saveList,
    contains  : contains,
    parseP2: parseP2,
    cache_get : cache_get,
    getServerDatetime: getServerDatetime,
    getServerDate: getServerDate,
    queryOne: queryOne,
    getServerWeekRange: getServerWeekRange,
    getServerLastWeekRange: getServerLastWeekRange,
    getServerMonthRange: getServerMonthRange,
    getServerNearThreeDaysRange: getServerNearThreeDaysRange
}



// WEBPACK FOOTER //
// ./src/network/request.js